import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 45 46"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#033CAA",
      "stroke-linecap": "square",
      "stroke-width": "2",
      d: "M36.8 22.54H7.36M26.385 12.126c0 5.353 4.715 10.414 10.415 10.414M26.385 32.954c0-5.353 4.715-10.414 10.415-10.414"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow-right"}) } }